import React from "react";
import { connect } from "react-redux";
import ControlButton from "./ControlButton";
import ExecuteActionButton from "containers/common/ExecuteActionButton";

// CUSTOMER-role accounts never see command buttons, on any turbine (2026-09-23
// request) - checked here, once, since every control-buttons list (Live tab,
// Advanced tab's Controls section, Settings) renders through this single
// shared leaf. This hides the buttons; the real enforcement is server-side
// (userHasActionRight() in Orbital-server/src/utils.js) regardless.
const ControlButtons = ({
  buttons,
  windTurbineIdentifier,
  useMqttCommand,
  userRole,
}) => {
  if (userRole === "CUSTOMER") {
    return null;
  }

  return (
    <div style={{ display: "flex", flexWrap: "wrap" }}>
      {buttons.map((b) => (
        <ExecuteActionButton
          key={b.cmd || b.function}
          action={b.dbname}
          name={b.function}
          windTurbineIdentifier={windTurbineIdentifier}
          useMqttCommand={useMqttCommand}
        >
          <ControlButton removePadding={true}>{b.function}</ControlButton>
        </ExecuteActionButton>
      ))}
    </div>
  );
};

const mapStateToProps = (state) => ({
  userRole: state.session.user && state.session.user.role,
});

export default connect(mapStateToProps)(ControlButtons);
